import { hasContrastWithWhite } from '@/helpers/colors'

export const getters = {
  GET_ACCOUNT_ID: state => state.accountId,
  GET_FIELDS: state => {
    const legalFields = state.fields.legal.map(field => {
      if (state.selectedCountry !== 'BRASIL') {
        if (field.name === 'phone') {
          const mask = state.selectedCountry === 'ARGENTINA' ? ['############'] : ['############']
          return { ...field, mask, validators: { required: true } }
        }
        if (field.name === 'birth_date') {
          return { ...field }
        }
        return { ...field, mask: null }
      }
      return { ...field }
    })
    const naturalFields = state.fields.natural.map(field => {
      if (state.selectedCountry !== 'BRASIL') {
        if (field.name === 'phone') {
          const mask = state.selectedCountry === 'ARGENTINA' ? ['+54 ############'] : ['+598 ############']
          return { ...field, mask, validators: { required: true } }
        }
        if (field.name === 'birth_date') {
          return { ...field }
        }
        return { ...field, mask: null }
      }
      return { ...field }
    })
    return {
      allowed_person_types_signup: [...state.fields.allowed_person_types_signup],
      legal: [...legalFields],
      natural: [...naturalFields]
    }
  },
  GET_ALLOWED_PERSON_TYPES_SIGNUP: state => state.allowed_person_types_signup,
  GET_IS_NATURAL_PERSON: state => (state.USER_INFO ? state.USER_INFO.person_type === 'N' : false),
  GET_ASSETS: state => {
    const assets = state.assets || {}

    // Ensure colors object exists
    if (!assets.colors) {
      assets.colors = {}
    }

    // Ensure whatsapp colors object exists with defaults
    if (!assets.colors.whatsapp) {
      assets.colors.whatsapp = {}
    }

    // Default WhatsApp colors
    const whatsappDefaults = {
      topSectionBackground: assets.colors.home.background,
      mainSectionBackground: '#ffffff',
      contactCardBackground: '#ffffff',
      contactCardTitle: '#000000',
      contactCardDescription: '#000000',
      contactButton: assets.colors.home.buttonBackground,
      contactButtonText: assets.colors.home.buttonFont,
      tutorialCardBackground: '#ffffff',
      tutorialCardStepBackground: '#ffffff',
      tutorialCardIcon:
        assets.colors.home.buttonFont && hasContrastWithWhite(assets.colors.home.buttonFont)
          ? assets.colors.home.buttonFont
          : assets.colors.home.buttonBackground,
      tutorialCardHeaderBackground: assets.colors.home.buttonBackground,
      tutorialCardHeaderFont: assets.colors.home.buttonFont
    }

    // Merge defaults with existing values (existing values take precedence)
    assets.colors.whatsapp = {
      ...whatsappDefaults,
      ...Object.fromEntries(Object.entries(assets.colors.whatsapp).filter(([_, v]) => v))
    }

    // Ensure images object exists
    if (!assets.images) {
      assets.images = {}
    }

    // Ensure whatsapp images object exists with defaults
    if (!assets.images.whatsapp) {
      assets.images.whatsapp = {}
    }

    // Default WhatsApp images (example placeholders)
    const whatsappImageDefaults = {
      // desktop: 'https://placehold.co/1075x400/ffffff/e0091b/png',
      // smartphone: 'https://placehold.co/330x600/ffffff/e0091b/png'
    }

    // Merge defaults with existing values (existing values take precedence)
    assets.images.whatsapp = {
      ...whatsappImageDefaults,
      ...assets.images.whatsapp
    }

    return assets
  },
  GET_TERMS: state => state.terms,
  GET_POSITION: state => state.position,
  LOADING: state => state.loading,
  LOADING_ID: state => state.loadingId,
  USER_INFO: state => state.userInfo,
  TOKEN: state => state.access_token,
  IS_APP: state => state.isApp,
  HIDDEN_EMAIL: state => state.hidden_email,
  HIDDEN_PHONE: state => state.hidden_phone,
  DELETE_REQUEST: state => state.delete_request,
  IS_CONFIRMED: state => state.is_confirmed,
  USER_EMAIL: state => state.user_email,
  CONTACTS: state => state.contacts,
  PIXEL: state => state.facebook_pixel_id,
  GOOGLE_ANALYTICS: state => state.google_analytics_id,
  ALLOWED_COUNTRIES: state => state.allowed_countries,
  UNEDITABLE_FIELDS: state => state.uneditable_fields,
  SELECTED_COUNTRY: state => state.selectedCountry,
  SMS_CHANNEL: state => state.smsChannel,
  COOLDOWN: state => state.cooldown,
  MESSAGE_SENT: state => state.message_sent,
  IS_RECOVER_SMS: state => state.is_recover_sms,
  SOCIAL_MEDIA: state => state.socialMedia,
  LOGIN_MENU: state => state.login_menu,
  SHOW_DELETE_BUTTONS: state => state.show_delete_buttons,
  SHOW_PARTIAL_DELETE_BUTTONS: state => state.show_partial_delete_buttons,
  ALLOWED_MODULES: state => state.allowed_modules,
  CAPTCHA_KEY: state => state.captcha_key,
  FINISH_SCREEN_WHATSAPP: state => state.finishScreenWhatsapp,
  APP_STORES: state => state.appStores,
  IS_EXTERNAL_AUTH: state => state.isExternalAuth,
  SIGNUP_TAG: state => state.signupTag,
  GET_WHATSAPP_TUTORIAL_STEPS: state => state.whatsappTutorialSteps,
  GET_WHATSAPP_HIDE_ARROWS_BREAKPOINT: state => {
    // Calculate minimum width needed for horizontal layout WITH arrows
    // Formula: (number of steps * min card width) + (number of arrows * arrow width) + gaps + padding
    const numSteps = state.whatsappTutorialSteps.length
    const numArrows = numSteps - 1
    const minCardWidth = 160 // Minimum card width
    const arrowWidth = 40 // Arrow width
    const itemGap = 16 // Gap between items (cards and arrows)
    const containerPadding = 40 // 20px on each side
    const totalGaps = (numSteps + numArrows - 1) * itemGap
    const minWidth = numSteps * minCardWidth + numArrows * arrowWidth + totalGaps + containerPadding
    return minWidth
  },
  GET_DOMAIN: () => {
    // Compute domain on demand to ensure window/location is available
    if (typeof window !== 'undefined' && location.hostname !== 'localhost') {
      return location.hostname
    }
    return 'cadastramento-demo.mercafacil.com'
  },
  GET_WHATSAPP_BOTS: state => state.whatsappBots,
  GET_WHATSAPP_STACK_BREAKPOINT: state => {
    // Calculate minimum width needed for horizontal layout WITHOUT arrows
    // Formula: (number of steps * min card width) + gaps + padding
    const numSteps = state.whatsappTutorialSteps.length
    const minCardWidth = 160 // Minimum card width
    const cardGap = 12 // Gap between cards when arrows are hidden
    const containerPadding = 40 // 20px on each side
    const minWidth = numSteps * minCardWidth + (numSteps - 1) * cardGap + containerPadding
    return minWidth
  }
}
